import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RenderTypes, ModalTypes } from '../Constants';
import _result from 'lodash/result';
import {} from '../actions';
import Utils from '../sources/Utils';
import Styles from './MissionSet/BaseComponent.cssmodule.less';

import Util from '../utils/util';

class Guide extends Component {
    constructor(props) {
        super(props);

        this.guidePopup = new entrylms.Modal();
        this.completePopup = new entrylms.Modal(undefined, {
            theme: this.props.theme,
        });
        this.renderTarget = $('<div>');
        this._mouseUpEvent = null;
        this._currentTargetChecker = null;
        this.runEventFunc = this.runEventFunc.bind(this);
        this.stopEventFunc = this.stopEventFunc.bind(this);
        this.container = null;
        this.endGuideData = [];
        this.isRestrictorCloseable = this.props.data.isRestrictorCloseable;
        this._mouseUpTimer = null;
    }

    componentDidMount() {
        this.toolTipRender = new entrylms.Render({
            target: this.renderTarget,
            theme: this.props.theme,
        });
        this.toolTipRender.on('click', (type) => {
            _blurAhead(this.restrictor.currentTooltip);

            switch (type) {
                case 'prev':
                    this.restrictor.end();
                    this.doBack();
                    this.isGuideDone = false;
                    break;
                case 'for_me':
                    this.skipAction(undefined, undefined, true);
                    break;
                case 'show_me':
                    this.showMe();
                    break;
            }
        });

        var initOption = {
            device: undefined,
            type: 'workspace',
            fonts: EntryStatic.fonts,
            libDir: '/lib',
            loadInterface: true,
        };

        initOption = Object.assign(this.props.data.injectOption, initOption, {
            doCommandAll: true,
        });

        if (this.props.data.asService) {
        } else if (Entry.type && Entry.type != 'invisible') {
            Entry.changeContainer(this.container);
            Entry.reloadOption(initOption);
        } else {
            Entry.init(this.container, initOption);
        }

        var WORKSPACE = Entry.getMainWS();

        if (this.restrictor) {
            this.restrictor.end();
        } else {
            this.restrictor = new Entry.Restrictor(this);
            this.restrictor.startEvent.attach(
                WORKSPACE,
                WORKSPACE.detachKeyboardCapture
            );
            this.restrictor.startEvent.attach(
                Entry.engine,
                Entry.engine.detachKeyboardCapture
            );
            this.restrictor.endEvent.attach(this, this.doneGuide);
        }
        Entry.commander.logEvent.attach(this, this._unbindMouseUpEvent);
        Entry.commander.logEvent.attach(this, this.validateGuide);
        Entry.commander.doEvent.attach(this, () => {
            if (this._mouseUpTimer) {
                clearTimeout(this._mouseUpTimer);
                this._mouseUpTimer = undefined;
            }
        });

        this.keyboarDoneEvent = Entry.keyPressed.attach(
            this,
            Entry.Utils.when(({ keyCode }) => {
                return /^(13|9)$/.test(keyCode);
            }, this.doneGuide)
        );

        Entry.addEventListener('run', this.runEventFunc);
        Entry.addEventListener('stop', this.stopEventFunc);

        WORKSPACE.widgetUpdateEvent.attach(this, () => {
            const r = this.restrictor;
            _result(r, 'renderTooltip');
            _result(r, 'align');
        });

        // do guide again
        // only when tooltip lost target element
        this.reDrawEvent = WORKSPACE.reDrawEvent.attach(this, () => {
            var wrapper = _.chain(this.restrictor)
                .result('currentTooltip')
                .result('data')
                .head()
                .result('wrapper')
                .head()
                .value();

            if (!wrapper) {
                return;
            }

            wrapper = $(wrapper);
            if (
                !parseInt(wrapper.css('left')) &&
                !parseInt(wrapper.css('top'))
            ) {
                return this.doGuide();
            }
        });

        if (Entry.windowResized) {
            this.windowResizedEvent = Entry.windowResized.attach(
                this,
                this.restrictor.align.bind(this.restrictor)
            );
        }

        this.setEntryProject(this.props.data);

        WORKSPACE.board.removeControl('wheel');
        WORKSPACE.blockMenu.removeControl('wheel');

        this.guidePopup.on('click', (type) => {
            if (type === 'next' || type === 'start' || type === 'close') {
                // INFO: 이곳이 팝업에서 다음 클릭 했을때 반응
                this.doneGuide();
            } else {
                // INFO: 이곳이 팝업에서 이전 클릭 했을때 반응
                this.restrictor.end();
                this.doBack();
                this.isGuideDone = false;
            }
        });

        this.completePopup.on('show', () => {
            const { stage } = Entry;
            stage.setEntitySelectable(false);
            stage.updateBoundRect();
        });

        this.completePopup.on('hide', () => {
            const { stage, container, engine, view_, engineContainer } = Entry;
            stage.setEntitySelectable(true);
            if (Entry.engineContainer) {
                engineContainer.insertBefore(
                    engine.view_,
                    engineContainer.firstChild
                );
            } else {
                view_.insertBefore(engine.view_, container.view_);
            }

            stage.updateBoundRect();
        });

        this.completePopup.on('click', (type) => {
            Entry.Curtain.hide();

            if (type === 'next' || type === 'submit') {
                Entry.engine.toggleStop();
                // INFO : 완료 액션
                let type = 'ExitStudy';

                entrylms.emit(type, {
                    category: 'guide',
                });
            } else {
                // INFO: 이곳이 팝업에서 이전 클릭 했을때 반응
                Entry.engine.toggleStop();
                this.restrictor.end();
                this.doBack();
                this.isGuideDone = false;
            }
        });
        WORKSPACE.setWidgetUpdateEveryTime(true);

        $(document).on(
            'mouseup.GuideRestrict',
            this.documentMouseUpFunc.bind(this)
        );

        $('body').css('overflow', 'hidden');
        this._generateHeader();

        const container = $(this.container);
        if (!Entry.objectEditable) container.addClass(Styles.objectNotEditable);
        else container.removeClass(Styles.objectNotEditable);

        function _blurAhead({ data } = {}) {
            if (_.isEmpty(data)) {
                return;
            }

            data = _.head(_.head(data).targetDom || []);
            if (data && data.tagName.toUpperCase() === 'INPUT') {
                data._focused = false;
            }
        }
    }

    componentWillUnmount() {
        Entry.commander.logEvent.clear();
        Entry.commander.doEvent.clear();

        Entry.getMainWS().blockMenu.disableMouseEvent = false;
        this.windowResizedEvent.destroy();
        this.keyboarDoneEvent.destroy();
        this.reDrawEvent.destroy();
        Entry.removeEventListener('run', this.runEventFunc);
        Entry.removeEventListener('stop', this.stopEventFunc);
        this._removeHeader();
        Entry.expectedAction = null;
        this.restrictor = null;
        $(document).off('mouseup.GuideRestrict');

        $(this.container).removeClass(Styles.objectNotEditable);
    }

    /* Lifecycle Events */
    componentDidUpdate(prevProps) {
        const previousId = prevProps.data ? prevProps.data._id : '';
        if (previousId !== this.props.data._id || this.props.data.reset) {
            if (this.props.data.injectOption) {
                Entry.reloadOption(this.props.data.injectOption, {
                    doCommandAll: true,
                });
            }
            this.setEntryProject(this.props.data);
            _result(Entry.stateManager, 'clear');
        }
    }

    /* Events Handler */

    /* User Function*/

    setEntryProject(data) {
        const { contents, basicProject } = data;
        if (basicProject) {
            Entry.clearProject();
            if (!basicProject.interface) basicProject.interface = {};
            else if (typeof basicProject.interface === 'string')
                basicProject.interface = JSON.parse(
                    JSON.stringify(basicProject.interface)
                );
            basicProject.interface.menuWidth = 244;
            basicProject.interface.canvasWidth = 325;
            Entry.loadProject(data.basicProject);
        }
        this.setAvailableBlocks(data);
        this.startGuide(contents);
    }

    setAvailableBlocks(data) {
        if (!data) return;

        const blockMenu = Entry.getMainWS().blockMenu;
        blockMenu.disableMouseEvent = false;

        var { availableBlocks: blockJSON } = data;

        var evt;

        if (this.props.data.asService) {
            blockMenu.setCategoryData(blockJSON);
            evt = blockMenu.categoryDoneEvent.attach(this, cb);
        } else {
            blockMenu.setNoCategoryData(Util.generateBlocks(blockJSON));
            cb();
        }

        function cb() {
            _result(evt, 'destroy');
            blockMenu.disableMouseEvent = true;
            Util.unbanHW();
        }
    }

    startGuide(contents) {
        this.contents = contents;
        this.guideIndex = 0;
        this.runGuideIndex = -1;
        this.isGuideDone = false;
        setTimeout(this.doGuide.bind(this), 250);
    }

    runEventFunc() {
        if (!Entry.engine.popup && !this.completePopup.isShowing()) {
            var className = 'buttonsHidden';
            if (this.props.theme) className += ` ${this.props.theme}`;
            Entry.engine.toggleFullScreen(className);
            Entry.engine.popup.removeMouseDispose();
        }
        Entry.Curtain.show(['stage', 'canvas']);
        Entry.engine.attachKeyboardCapture();
    }

    stopEventFunc() {
        if (Entry.engine.popup && !this.completePopup.isShowing())
            Entry.engine.closeFullScreen();
        Entry.engine.detachKeyboardCapture();
        $('body').css('overflow', 'hidden');
    }

    get currentGuide() {
        return this.contents[this.guideIndex];
    }

    doGuide(skip) {
        if (this.guideIndex >= this.contents.length) {
            return this.endGuide();
        }

        const blockMenu = Entry.getMainWS().blockMenu;
        blockMenu.disableMouseEvent = true;

        console.log('do : ' + this.guideIndex);

        this.runGuideIndex = this.guideIndex;
        var guide = this.currentGuide;
        this.isGuideDone = false;
        switch (guide.type) {
            case 'popup':
                const { data } = this.props;
                const { content } = guide;
                let isEndGuide = false;
                const popupData = content.map((item) => {
                    if (item.type === ModalTypes.INTRO) {
                        item.title = item.title || data.parentTitle || '';
                        if (item.title.toUpperCase() === '[%ENDGUIDE%]') {
                            isEndGuide = true;
                        }
                    }
                    return item;
                });

                if (!isEndGuide) {
                    this.guidePopup.modalData = popupData;
                    this.guidePopup.show();
                } else {
                    guide.isEndGuide = true;
                    this.endGuideData = popupData;
                    this.isGuideDone = false;
                    this.guideIndex++;
                    this.doGuide();
                }
                break;
            case 'action':
                this._bindMouseUpEvent();
                _result(Entry.disposeEvent, 'notify');

                let restrictData = guide;
                let [commandType] = guide.content;
                let command = Entry.Command[commandType];

                if (!guide.tooltip) {
                    guide.tooltip = {};
                }

                let guideTooltip = guide.tooltip;

                const strippedTitle = (guideTooltip.title || '')
                    .replace(/&nbsp;/gi, '')
                    .trim();
                const strippedContent = (guideTooltip.content || '')
                    .replace(/&nbsp;/gi, '')
                    .trim();
                if (
                    Lang.CommandTooltip[commandType] &&
                    (_.isEmpty(strippedTitle) || _.isEmpty(strippedContent))
                ) {
                    var defaultGuide = Lang.CommandTooltip[commandType];
                    defaultGuide = defaultGuide.split('@@');

                    if (_.isEmpty(strippedTitle))
                        guideTooltip.title = defaultGuide[0];

                    if (_.isEmpty(strippedContent) && defaultGuide[1])
                        guideTooltip.content = defaultGuide[1];
                    else if (!guide.content)
                        guideTooltip.content = defaultGuide[0];
                    guideTooltip.isDefault = true;
                }

                this.toolTipRender.renderData = {
                    type: RenderTypes.TOOL_TIP,
                    content: guide.tooltip,
                    isShowMe: command.showMe,
                    isForMe: true,
                    isPrev: this.guideIndex !== 0,
                    guideIndex: this.guideIndex,
                };
                restrictData = Object.assign({}, guide, {
                    tooltip: Object.assign({}, guide.tooltip, {
                        content: this.renderTarget,
                    }),
                });

                if (restrictData.skip || skip === true) {
                    this.skipAction(skip, restrictData);
                } else
                    this.restrictor.restrict(restrictData, this.toolTipRender);
                break;
            case 'checkScript':
                //TODO data type and name edit
                this.setCheckScript(guide.content);
                this.isGuideDone = false;
                this.guideIndex++;
                this.doGuide();
                break;
        }
    }

    doneGuide() {
        var { type } = this.currentGuide;
        Entry.getMainWS().blockMenu.disableMouseEvent = false;

        if (type === 'popup') {
            this.guideIndex++;
            this.doGuide();
        } else {
            this.isGuideDone = true;
        }
    }

    validateGuide(data) {
        const [commandType] = data;
        var { recordable, validate } = Entry.Command[commandType];
        switch (recordable) {
            case Entry.STATIC.RECORDABLE.SUPPORT:
                if (!this.isGuideDone || this.reverseGuide) {
                    return;
                }

                var guide = this.contents[this.guideIndex];
                if (
                    (validate === false && commandType === guide.content[0]) ||
                    isEqual(guide.content, data)
                ) {
                    this.isGuideDone = false;
                    this.restrictor.end();
                    this.guideIndex++;
                    if (
                        commandType ===
                            Entry.STATIC.COMMAND_TYPES
                                .insertBlockFollowSeparate ||
                        commandType ===
                            Entry.STATIC.COMMAND_TYPES
                                .insertBlockFromBlockMenuFollowSeparate
                    )
                        this.guideIndex++;

                    setTimeout(() => {
                        this.doGuide();
                    });
                } else {
                    this.restrictor.end();
                    this.guideIndex++;
                    this.doBack();
                    this.isGuideDone = false;
                }
                break;
            case Entry.STATIC.RECORDABLE.SKIP:
            case Entry.STATIC.RECORDABLE.ABANDONE:
                break;
        }

        function isEqual(a, b) {
            if (a.length !== b.length) return false;

            a = JSON.parse(JSON.stringify(a));
            b = JSON.parse(JSON.stringify(b));

            //log type checking
            if (a.shift() !== b.shift()) return false;

            var _mapper = (v) =>
                _.isNumber(v) ? Number(Entry.Utils.toFixed(v, 2)) : v;

            for (var i = 0; i < a.length; i++) {
                const [nameA, dataA] = a[i];
                const [nameB, dataB] = b[i];

                if (nameA !== nameB) return false;
                //do not check for specific x,y points
                if (/^(x|y)$/.test(nameA)) {
                    continue;
                } else if (new RegExp(/block|pointer/, 'gi').test(nameA)) {
                    dataA.splice(0, 2);
                    dataB.splice(0, 2);
                }

                //map to get fixed version of number
                if (!_.isEqual(_mapper(dataA), _mapper(dataB))) {
                    return false;
                }
            }

            return true;
        }
    }

    doBack() {
        Entry.expectedAction = null;

        var prevGuide = this.contents[this.guideIndex - 1];
        if (!prevGuide) return this.doGuide();
        var guide = this.contents[this.guideIndex];
        if (!guide) guide = prevGuide;
        switch (prevGuide.type) {
            case 'popup':
                this.guideIndex--;
                if (!prevGuide.isEndGuide) {
                    this.doGuide();
                } else {
                    this.doBack();
                }
                break;
            case 'action':
                setTimeout(() => {
                    this.reverseGuide = true;
                    if (Entry.engine.isState('run')) {
                        Entry.engine.toggleStop();
                    }
                    var newIndex = this.getPrevIndex();
                    let undoCnt = this.guideIndex - newIndex;
                    let guide = this.contents[newIndex];

                    if (guide.type !== 'action') {
                        undoCnt--;
                    }

                    Entry.stateManager.undo(undoCnt);
                    this.guideIndex = newIndex;
                    this.reverseGuide = false;
                    this._requestDoGuide();
                });
                break;
            case 'checkScript':
                this.guideIndex--;
                this.doBack();
                break;
        }
    }

    getPrevIndex() {
        var index = this.guideIndex - 1;
        while (index > 0) {
            var guide = this.contents[index];
            if (guide.skip) {
                index--;
                continue;
            }

            guide = this.contents[index - 1];
            if (guide.type !== 'action') break;
            var cmd = Entry.Command[guide.content[0]];
            if (cmd.followCmd !== true) break;
            else index--;
        }
        return index;
    }

    endGuide() {
        const { data } = this.props;
        const [endGuideData] = this.endGuideData;
        const modalData = {
            type: 'COMPLETE',
            titleType: 'SUCCESS',
            title: Utils.getLang('Menus.success'),
            isHomework: data.isHomework,
            isHomeworkLapse: data.isHomeworkLapse,
            isLastStudy: data.isLastStudy,
            content: Utils.getLang('Menus.mission_modal_content_success'),
            media: {
                category: 'PROJECT_ELEMENT',
                content: Entry.engine.view_,
            },
        };
        if (endGuideData) {
            modalData.content = endGuideData.content;
            modalData.media = endGuideData.media;
        }
        this.completePopup.modalData = [modalData];
        this.completePopup.itemIndex = 0;
        this.completePopup.show();
        Entry.getMainWS().attachKeyboardCapture();
        Entry.engine.attachKeyboardCapture();
    }

    render() {
        return (
            <div
                id={Styles.guideComponent}
                className={Styles.wsComponent}
                ref={(div) => {
                    this.container = div;
                }}
            />
        );
    }

    checkAchieve(result) {
        if (
            this.guideIndex > this.contents.length ||
            this.completePopup.isShowing()
        )
            return;

        if (this.contents[this.guideIndex].content[0] !== 501) return;

        switch (result) {
            case 'success':
                this.isGuideDone = false;
                this.restrictor.end();
                this.guideIndex++;
                this.doGuide();
                break;
            case 'fail':
                this.restrictor.end();
                this.doGuide();
                this.isGuideDone = false;
                break;
        }
    }

    setCheckScript(script) {
        this.clearCheckScript();

        this._currentTargetChecker = Entry.container.addExtension(
            new Entry.TargetChecker(script, false)
        );

        Entry.achieveEvent.attach(this, this.checkAchieve);
    }

    clearCheckScript() {
        if (this._currentTargetChecker)
            Entry.container.removeExtension(this._currentTargetChecker);
        this._currentTargetChecker = null;
    }

    skipAction(isPass, restrictData, isForMe) {
        const {
            content: [commandType, ...args],
        } = this.contents[this.guideIndex];
        const { followCmd } = Entry.Command[commandType];
        const {
            toggleRun,
            insertBlockFromBlockMenuFollowSeparate,
        } = Entry.STATIC.COMMAND_TYPES;
        const restrictor = this.restrictor;

        if (restrictData) {
            restrictor.restrict(restrictData);
        }

        if (commandType === toggleRun) {
            this.isGuideDone = false;
        } else {
            this.isGuideDone = true;
        }
        restrictor.end();
        requestAnimationFrame(() => {
            Entry.do(commandType, ...args.map((l) => l[1])).isPass(
                isPass === true
            );

            if (
                commandType !== toggleRun &&
                commandType !== insertBlockFromBlockMenuFollowSeparate &&
                followCmd &&
                isForMe
            ) {
                this.doGuide(followCmd);
            }
        });
    }

    showMe() {
        const {
            content: [content],
        } = this.contents[this.guideIndex];
        const command = Entry.Command[content];
        if (!command.showMe) return;
        command.showMe(this.restrictor);
    }

    requestNextData() {
        return this.contents[this.guideIndex + 1];
    }

    _unbindMouseUpEvent() {
        _result(this._mouseUpEvent, 'destroy');
        this._mouseUpEvent = null;
        this._actionDoneData = {
            isDone: true,
        };
    }

    _bindMouseUpEvent() {
        this._unbindMouseUpEvent();
        this._actionDoneData = {
            index: this.guideIndex,
            isDone: false,
        };
        this._mouseUpEvent = Entry.getMainWS().blockViewMouseUpEvent.attach(
            this,
            function() {
                const {
                    content: [commandType],
                } = this.contents[this.guideIndex];
                const { disableMouseUpDispose } = Entry.Command[commandType];
                if (!disableMouseUpDispose) {
                    setTimeout(this.doGuide.bind(this), 50);
                }
            }
        );
    }

    _requestDoGuide() {
        if (this.isGuideRequested) {
            return;
        }

        this.isGuideRequested = true;
        setTimeout(() => {
            this.isGuideRequested = false;
            this.doGuide();
        }, 50);
    }

    documentMouseUpFunc({ target }) {
        this._mouseUpTimer = setTimeout(() => {
            const data = this._actionDoneData;

            if (
                data === undefined ||
                Entry.Curtain.isVisible() ||
                $(target).hasClass('entryCurtainElem')
            ) {
                return;
            }

            const { isDone, index } = data;

            if (!isDone && this.guideIndex === index) {
                setTimeout(this.doGuide.bind(this), 50);
            }
        }, 150);
    }

    _generateHeader() {
        const header = $(
            `<div class="${
                Styles.headerAboveCurtain
            }"><a href="/"><img src="/img/assets/workspace_header_logo_white.png"/></a></div>`
        );
        $('body').append(header);
        header.on('mousedown', () => {
            Entry.disposeEvent.notify(undefined, true);
        });
        $('.headerLogo').css('visibility', 'hidden');
    }

    _removeHeader() {
        $(`.${Styles.headerAboveCurtain}`).remove();
        $('.headerLogo').css('visibility', 'visible');
    }
}

Guide.displayName = 'Guide';
Guide.propTypes = {};
Guide.defaultProps = {
    data: {
        title: '',
    },
};

export default Guide;



// WEBPACK FOOTER //
// ./components/Guide.js